import script from "./AdventCalenderForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdventCalenderForm.vue?vue&type=script&lang=ts&setup=true"

import "./AdventCalenderForm.vue?vue&type=style&index=0&id=57d53185&lang=scss"

const __exports__ = script;

export default __exports__